<template>
  <div class="detail-page">
    <!-- 随堂测试 -->
    <van-popup round v-model:show="examinShow" closeable @click-close-icon="examinShow = false">
      <div class="exmainMain" v-if="examin">
        <h5>随堂测试</h5>
        <p>
          <!-- <span>{{ examin.typeName }}：</span> -->
          {{ examin.name }}
        </p>
        <div class="options">
          <p @click="examinSelect = item.id" :class="{ active: item.id == examinSelect }" v-for="item in examinOptions"
            :key="item.id">
            {{ item.name }}
          </p>
        </div>
        <button @click="examinSubmit" :class="{ gray: currentInfo.test_status == 1 }">
          提交
        </button>
      </div>
    </van-popup>
    <!-- <van-nav-bar
      ref="nav"
      :border="false"
      @click-left="back"
      placeholder
      :fixed="true"
      :title="name || '课程详情'"
    >
      <template #left>
        <van-icon size="20px" name="arrow-left" color="#333" />
      </template>
</van-nav-bar> -->
    <van-popup v-model="show" position="bottom">
      <div class="share-box">
        <div @click="
          show2 = true;
        show = false;
        ">
          <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share3.png" alt="" />
          微信
        </div>
        <div @click="copy">
          <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share2.png" alt="" />
          复制链接
        </div>
      </div>
    </van-popup>
    <div class="share-wrap" @click="show2 = false" v-show="show2">
      <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share1.png" alt="" />
      <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share4.png" alt="" />
    </div>
    <div class="playTab">
      <ul>
        <li v-if="currentInfo.video_ids && currentInfo.video_ids.length"
          @click=" menuIndex = 1; pdfUrl = ''; player.play();" :class="{ active: menuIndex == 1 }">视频</li>
        <li v-if="currentInfo.pdf_an" @click=" menuIndex = 'jiaoan'; pdfUrl = currentInfo.pdf_an;"
          :class="{ active: menuIndex == 'jiaoan' }">教案</li>
        <li v-if="currentInfo.pdf_ppt" @click=" menuIndex = 'ppt'; pdfUrl = currentInfo.pdf_ppt;"
          :class="{ active: menuIndex == 'ppt' }">PPT</li>
        <li v-if="currentInfo.pdf_examine" @click=" menuIndex = 'kaohe'; pdfUrl = currentInfo.pdf_examine;"
          :class="{ active: menuIndex == 'kaohe' }">考核表</li>
      </ul>
    </div>
    <div class="pdfMain" v-show="menuIndex != 1">
      <p>{{ currentInfo.name }}</p>
      <pdf-view :pdfUrl="pdfUrl" :isAbsolute="false"></pdf-view>
    </div>
    <div class="video-wrap" v-show="menuIndex == 1">
      <div class="coverImg" v-show="!player">
        <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 2限免，1不限免-->
        <!-- <div class="tip">
          
          <img :src="$free" v-if="is_free==2"/>
          <img :src="$vip" v-else-if="is_vip==1"/>
          <img :src="$noVip" v-else>
        </div> -->
        <van-image class="price-cover" fit="cover" :error-icon="$placeImg" :loading-icon="$placeImg" :src="cover"
          alt=""></van-image>
      </div>
      <van-icon size="20px" class="back" @click="back" name="arrow-left" color="#ddd" />
      <div class="video" :style="{ opacity: examinShow ? 0 : 1 }" id="video" v-show="player"></div>
      <div class="share" @click="show = true" v-if="plat != 120 && (goods_id != '776' && goods_id != '775')">
        <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share_icon.png" />
        分享
      </div>
    </div>
    <div class="main" v-show="menuIndex == 1">
      <div class="videoName">
        <p>{{ currentInfo.name }}</p>
        <span v-if="examin">请认真听讲，本节课结束请作答随堂测评。</span>
      </div>
      <div class="contentMain" v-if="currentInfo.map && currentInfo.map.length">
        <img :src="item.cover" v-for="(item, index) in currentInfo.map" :key="index" />
      </div>
      <div class="contentMain" v-if="currentInfo.handouts && currentInfo.handouts.length">
        <img :src="item.cover" v-for="(item, index) in currentInfo.handouts" :key="index" />
      </div>
    </div>
    <div class="footer">
      <p @click="changeVideo('pre')" :class="{ gray: currentIndex == 0 }">上一节</p>
      <p class="examin" v-if="examin" @click="examinShow = true;">随堂测评</p>
      <p @click="changeVideo('next')" :class="{ gray: currentIndex == list.length - 1 }">下一节</p>
    </div>
  </div>
</template>

<script>
import pdfView from '@/components/pdfView.vue'
export default {
  components: { pdfView },
  computed: {
    partalName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id
    },
    userName() {
      return JSON.parse(localStorage.getItem('userdata')).nickname
    },
    vipInfo() {
      return this.$store.state.vipInfo
    }
  },
  data() {
    return {
      pdfUrl: '',
      show: false,
      show2: false,
      videoContext: "",
      active: -1,
      playId: 0,
      price: "",
      content_app: "",
      content_img: "",
      name: "",
      lessonList: [],
      is_buy: 0,
      is_vip: 0,
      is_free: 0,
      player: "",
      goods_sku_id: "",
      examinInfo: null,
      currentInfo: null,
      plat_vip: null,
      duration: 0,
      currentTime: '',
      totalTime: 0,
      timeStart: 0,
      cover: '',
      color: ['#666', '#FF4D41', '#6DD400'],
      currentIndex: -1,
      menuIndex: '',

      examinShow: false,
      examinOptions: [
        {
          id: 1,
          title: "选项一",
        },
      ],
      pass: "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/examinPass.png",
      noPass:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/examinNoPass.png",
      radioImg:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/radio.jpg",
      radioAImg:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/radioActive.jpg",
      topData: [],
      id: "",
      type: "",
      player: "",
      from: "",
      url: "",
      goods_id: "",
      videoId: "",
      duration: 0,
      currentTime: "",
      timeStart: 0,
      totalTime: 0,
      examin: null,
      examinSelect: 0,
      baseInfo: {},
      lessonId: "",
      list: [],
      lessonList: [],
      currentIndex: -1,
      currentInfo: {},
      isPass: 0,
      type: false, // false课程 true示范课
      videoType: '',
    };
  },
  watch: {
    currentIndex() {
      // this.getVideo()

    }
  },
  async mounted() {

    this.lessonId = this.$route.query.lesson_id;
    this.goods_id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.pdfUrl = ''
    this.getInit();
  },
  methods: {
    changeVideo(type) {
      if (
        (type == "pre" && this.currentIndex == 0) ||
        (type == "next" && this.currentIndex == this.list.length - 1)
      ) {
        this.$toast("没有了");
        return;
      } else {
        // this.totalTime = parseInt(this.player ? this.player.getDuration() : 0);
        // this.currentTime = parseInt(
        //   this.player ? this.player.getCurrentTime() : 0
        // );
        this.addHistory();
        this.currentIndex =
          type == "pre" ? this.currentIndex - 1 : this.currentIndex + 1;
        this.currentInfo = this.list[this.currentIndex];
        this.getExamin();
        console.log(this.currentInfo)
        this.pdfUrl = ''
        if (this.currentInfo.video_ids) {
          this.getVideo();
          this.menuIndex = 1
          return
        }
        if (this.currentInfo.pdf_an) {
          this.menuIndex = 'jiaoan'
          this.pdfUrl = this.currentInfo.pdf_an
          return
        }
        if (this.currentInfo.pdf_ppt) {
          this.menuIndex = 'ppt'
          this.pdfUrl = this.currentInfo.pdf_ppt
          return
        }
        if (this.currentInfo.pdf_examine) {
          this.menuIndex = 'kaohe'
          this.pdfUrl = this.currentInfo.pdf_examine
          return
        }
        this.$toast("当前章节没有资料");
      }
    },

    async getInit() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      });
      let res = await this.$request.tuoyuDetail({ goods_id: this.goods_id });
      console.log(res)
      if (res.code != 0) {
        this.$toast(res.msg);
        return
      }
      if (!res.data.is_buy && parseFloat(res.data.price)) {
        this.$toast('当前课程还未购买，请购买后再观看');
        setTimeout(() => {
          window.history.back()
        }, 1500)
        return
      }
      if (res.code == 0) {
        this.lessonList = res.data.list;
        if (this.type) {
          this.list = res.data.demonstrate;
        } else if (this.$route.query.lessonType) {
          this.list = this.flatArr(res.data.down_list, []);
        } else {
          this.list = this.flatArr(res.data.list, []);
        }
        // console.log(this.list);
        this.baseInfo = res.data.goods_info; //课程介绍
        this.baseInfo.is_buy = res.data.is_buy;
        this.baseInfo.goods_course_id = res.data.goods_course_id;
        this.baseInfo.test_id = res.data.base.test_id;
        let id =
          this.$route.query.speak_id ||
          this.$route.query.chapter_id ||
          this.$route.query.lesson_id;
        this.currentIndex = this.list.findIndex((item, index) => {
          return (
            (!item.myType && item.id == this.$route.query.chapter_id) ||
            (item.myType == "lesson" &&
              item.id == this.$route.query.lesson_id) ||
            (item.myType == "speak" && item.id == this.$route.query.speak_id)
          );
        });
        // console.log(this.currentIndex);
        this.currentInfo = this.list[this.currentIndex];
        console.log('this.currentInfo')
        console.log(this.currentInfo)
        this.getExamin();
        if (this.currentInfo.video_ids) {
          this.menuIndex = 1
          this.getVideo();
          return
        }
        if (this.currentInfo.pdf_an) {
          this.menuIndex = 'jiaoan'
          this.pdfUrl = this.currentInfo.pdf_an
          return
        }
        if (this.currentInfo.pdf_ppt) {
          this.menuIndex = 'ppt'
          this.pdfUrl = this.currentInfo.pdf_ppt
          return
        }
        if (this.currentInfo.pdf_examine) {
          this.menuIndex = 'kaohe'
          this.pdfUrl = this.currentInfo.pdf_examine
          return
        }


      } else {
        this.$toast(res.msg);
      }
    },
    flatArr(arr, idArr) {
      let myArr = [];

      arr.forEach((item) => {
        if (item.lesson && item.lesson.length) {
          // console.log("lesson");
          let arr = [
            { label: "chapterId", value: item.id },
            { label: "myType", value: "lesson" },
          ];
          // console.log(idArr);
          myArr.push(...this.flatArr(item.lesson, [...idArr, ...arr]));
        } else if (item.speak && item.speak.length) {
          // console.log("speak");
          let arr = [
            { label: "lessonId", value: item.id },
            { label: "myType", value: "speak" },
          ];
          myArr.push(...this.flatArr(item.speak, [...idArr, ...arr]));
        } else {
          // console.log("none");
          idArr.forEach((v) => {
            item[v.label] = v.value;
          });
          myArr.push(item);
        }
      });
      return myArr;
    },
    async getVideo() {
      this.$toast.loading({
        message: '视频加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      });
      // 切换视频时记录上一个视频的观看时长
      if (this.player) {
        this.videoType != 'cc' ? this.player.dispose() : this.player.destroy();
        this.totalTime = parseInt(this.player.getDuration())
        this.currentTime = parseInt(this.videoType == 'cc' ? this.player.getPosition() : this.player.getCurrentTime())
        this.duration = this.timeStart ? parseInt((new Date().getTime() - this.timeStart.getTime()) / 1000) : 0
        // this.addHistory()
      }
      let videoInfo = this.currentInfo.video_ids[0].resource[0];
      let id = videoInfo.ali_media_id;
      if (id) {
        this.videoType = 'ali'
        let res = await this.$api({
          method: "get",
          url: "/api/video/play-auth/get",
          data: {
            video_id: id,
          },
        });
        if (res.code == 0) {

          this.player = new Aliplayer(
            {
              id: "video",
              width: "100%",
              height: "100%",
              vid: res.data.videoId,
              playauth: res.data.playAuth,
            },
            function (player) {
              this.$toast.clear()
              // console.log("The player is created1.");
            }
          );
          this.player.on('play', () => {
            this.timeStart = new Date()
            // console.log(this.timeStart)
          })
          this.player.on('pause', () => {
            if (this.player) {
              this.totalTime = parseInt(this.player.getDuration())
              this.currentTime = parseInt(this.player.getCurrentTime())
              // console.log(new Date())

            }
            this.addHistory()
          })
        } else {
          this.$toast(res.msg);
        }
      } else if (videoInfo.url) {
        this.videoType = 'url'
        this.player = new Aliplayer(
          {
            id: "video",
            width: "100%",
            height: "100%",
            autoplay: true,
            source: videoInfo.url,
            cover: videoInfo.cover || this.cover
          },
          function (player) {
            this.$toast.clear()
            // console.log("The player is created2.");
          }
        );
        this.player.on('play', () => {
          this.timeStart = new Date()
          // console.log(this.timeStart)
        })
        this.player.on('pause', () => {
          if (this.player) {
            this.totalTime = parseInt(this.player.getDuration())
            this.currentTime = parseInt(this.player.getCurrentTime())
            // console.log(new Date())

          }
          this.addHistory()
        })
      } else if (videoInfo.ccid) {
        this.videoType = 'cc'

        this.player = window.createCCH5Player({
          vid: videoInfo.ccid,
          siteid: "23EEB4513490D389",
          // vid: 'AA22BDEE61E7455A9C33DC5901307461',
          // siteid: "2661F9756E5C832E",
          autoStart: true,
          playertype: 1,
          isShare: "false",
          banDrag: "false",
          width: "100%",
          height: "100%",
          loop: "true",
          showFullScreenBtn: "false",
          useX5Play: "true",
          isShowUrlBtn: "false",
          isShowMoreBtn: "false",
          objectFit: "cover", // contain 、 fill 、 cover
          parentNode: "#video",
        });
        // this.player = window.createCCH5Player({
        //             vid: 'AA22BDEE61E7455A9C33DC5901307461',
        //             siteid: "2661F9756E5C832E",
        //             autoStart: true,
        //             width: "100%",
        //             height: "380px",
        //             parentNode: document.getElementById('player')
        //         });
        window.on_h5player_error = (err) => {
          console.log('失败')
          console.log(err)
        }
        window.on_CCH5player_ready = (obj) => {


        };
        window.on_CCH5player_play = (obj) => {
          this.timeStart = new Date()
        }
        window.on_CCH5player_pause = (obj) => {
          if (this.player) {
            this.totalTime = parseInt(this.player.getDuration())
            this.currentTime = parseInt(this.player.getPosition())
            // console.log(new Date())

          }
          this.addHistory()
        }

      }
    },
    async getExamin() {
      this.examin = null;
      this.isPass = 0;
      if (this.type) return;
      let param = {
        lesson_id:
          this.currentInfo.myType && this.currentInfo.myType == "lesson"
            ? this.currentInfo.id
            : "",
        chapter_id: this.currentInfo.myType ? "" : this.currentInfo.id,
        speak_id:
          this.currentInfo.myType && this.currentInfo.myType == "speak"
            ? this.currentInfo.id
            : "",
      };
      let myParam = {};
      for (let [k, v] of Object.entries(param)) {
        if (v) {
          myParam[k] = v;
        }
      }
      let res = await this.$request.tuoyuExamin(myParam);
      if (res.code == 0) {
        if (!res.data || !res.data.id) {
          return;
        }
        this.examin = res.data;
        // if(this.examin.name.indexOf('：')!=-1){
        //   this.examin.typeName = this.examin.name.slice(0,this.examin.name.indexOf('：'))
        //   this.examin.titleName = this.examin.name.slice(this.examin.name.indexOf('：')+1)
        // }else if(this.examin.name.indexOf(':')!=-1){
        //   this.examin.typeName = this.examin.name.slice(0,this.examin.name.indexOf(':'))
        //   this.examin.titleName = this.examin.name.slice(this.examin.name.indexOf(':')+1)
        // }

        this.examinOptions = [];
        this.examinSelect = -1;

        if (this.examin.type == 1) {
          //选择题
          if (this.examin.item_one) {
            this.examinOptions.push({
              name: this.examin.item_one,
              id: 1,
            });
          }
          if (this.examin.item_two) {
            this.examinOptions.push({
              name: this.examin.item_two,
              id: 2,
            });
          }
          if (this.examin.item_three) {
            this.examinOptions.push({
              name: this.examin.item_three,
              id: 3,
            });
          }
          if (this.examin.item_four) {
            this.examinOptions.push({
              name: this.examin.item_four,
              id: 4,
            });
          }
          if (this.currentInfo.test_status == 1) {
            //已通过测试，直接显示
            this.isPass = 1;
            this.examinSelect = this.examin.answer;
          }
        } else {
          this.examinOptions = [
            {
              name: "正确",
              id: 1,
            },
            {
              name: "错误",
              id: 2,
            },
          ];
          if (this.currentInfo.test_status == 1) {
            //已通过测试，直接显示
            this.isPass = 1;
            this.examinSelect = this.examin.judge;
          }
        }
      } else {
        this.$toast(res.msg);
      }
    },
    async examinSubmit() {
      if (this.currentInfo.test_status == 1) {
        return;
      }
      if (this.examinSelect == -1) {
        this.$toast("请选择答案");
        return;
      }
      let param = {
        test_id: this.examin.id,
        type: this.examin.type,
      };
      if (this.examin.type == 1) {
        //选择题
        param.item = this.examinSelect;
      } else {
        param.judge = this.examinSelect;
      }
      let res = await this.$request.tuoyuExaminSubmit(param);
      if (res.code == 0) {

        if (this.examin.type == 1) {
          this.isPass = res.data.choose_answer == this.examinSelect ? 1 : 2;
        } else {
          this.isPass = res.data.judge_answer ? 1 : 2;
        }
        if (this.isPass == 1) {
          this.$toast.success('测试通过')
          this.examinShow = false
        } else {
          this.$toast.fail({
            className: 'myToast',
            message: '答案错误',
          })
        }
        this.currentInfo.test_status = this.isPass;

      } else {
        this.$toast(res.msg);
      }
    },

    toPage(url) {
      this.$router.push(url)
    },
    back() {
      this.$router.go(-1);
    },
    async playVideo(item) {
      if (!item) return


      if (this.plat == '120' || item.is_buy == 1 || item.is_show == 1 || true) {
        this.playId = item.value;
        this.content_app = item.content_app;
        let id = item.resource[0].video_id;

        // 切换视频时记录上一个视频的观看时长
        if (this.player) {
          this.totalTime = parseInt(this.player.getDuration())
          this.currentTime = parseInt(this.player.getCurrentTime())
          this.duration = this.timeStart ? parseInt((new Date().getTime() - this.timeStart.getTime()) / 1000) : 0
          this.addHistory()
        }


        this.currentInfo = item
        console.log('this.currentInfo')
        console.log(this.currentInfo)
        if (id) {
          let vid = id;
          let res = await this.$api({
            url: "/api/video/play-auth/get",
            data: {
              video_id: vid,
            },
          });
          if (res.code == 0) {
            // console.log(this.player, res.data);

            if (this.player) {
              this.player.dispose();
              // this.player.replayByVidAndPlayAuth({
              //   vid: res.data.videoId,
              //   playauth: res.data.playAuth,
              // });
              // return;
            }
            this.player = new Aliplayer(
              {
                id: "video",
                width: "100%",
                height: "100%",
                vid: res.data.videoId,
                playauth: res.data.playAuth,
              },
              function (player) {
                // console.log("The player is created1.");
              }
            );
          }
        } else if (item.resource[0].ccid) {
          let vid = item.resource[0].ccid;
          if (this.player) {
            this.player.changeVideo(vid);
            return;
          }
          // console.log(vid);
          this.player = window.createCCH5Player({
            vid: vid,
            siteid: "23EEB4513490D389",
            autoStart: true,
            playertype: 1,
            isShare: "false",
            banDrag: "false",
            width: "100%",
            height: "100%",
            loop: "true",
            showFullScreenBtn: "false",
            useX5Play: "true",
            isShowUrlBtn: "false",
            isShowMoreBtn: "false",
            objectFit: "cover", // contain 、 fill 、 cover
            parentNode: ".video",
          });
        } else if (item.resource[0].url) {
          if (this.player) {
            this.player.dispose();
            // this.player.replayByVidAndPlayAuth({
            //   vid: res.data.videoId,
            //   playauth: res.data.playAuth,
            // });
            // return;
          }
          this.player = new Aliplayer(
            {
              id: "video",
              width: "100%",
              height: "100%",
              autoplay: true,
              source: item.resource[0].url,
              cover: item.resource[0].cover || this.cover
            },
            function (player) {
              // console.log("The player is created2.");

            }
          );
        } else {
          if (this.player) {
            this.player.dispose();
          }
          this.$toast('当前没有视频')
        }
        this.player.on('play', () => {
          // console.log('play')
          this.timeStart = new Date()
          // console.log(this.timeStart)
        })
        this.player.on('pause', () => {
          // console.log('暂停')
          if (this.player) {
            this.totalTime = parseInt(this.player.getDuration())
            this.currentTime = parseInt(this.player.getCurrentTime())
            // console.log(new Date())

          }
          this.addHistory()
        })
      } else {
        this.content_app = item.content_app;
        this.$toast("请购买后开始学习")
      }
    },
    copy() {
      this.$copyText(String(window.location.href))
        .then((res) => {
          this.$toast("复制成功");
          this.show = false;
        })
        .catch((e) => {
          this.$toast("复制失败");
          this.show = false;
        });
    },
    async addHistory() {
      if (this.type || !this.currentInfo.video_ids) return;
      console.log("history");
      let data = this.currentInfo;
      this.duration = this.timeStart
        ? parseInt((new Date().getTime() - this.timeStart.getTime()) / 1000)
        : 0;
      console.log(data);
      console.log(this.duration);
      // if(!data || this.duration<5) return
      this.timeStart = 0;
      let res = await this.$request.tuoyuRecord({
        lesson_id:
          this.currentInfo.myType && this.currentInfo.myType == "lesson"
            ? this.currentInfo.id
            : 0,
        chapter_id: this.currentInfo.myType ? 0 : this.currentInfo.id,
        speak_id:
          this.currentInfo.myType && this.currentInfo.myType == "speak"
            ? this.currentInfo.id
            : 0,
        goods_course_id: this.baseInfo.goods_course_id,
        status: this.currentTime && (this.totalTime - this.currentTime) < 6 ? 1 : 0,
        duration: this.duration,
        flat_id: this.plat,
        playmode_id: this.currentInfo.video_ids[0].id,
      });
    },
  },
  beforeDestroy() {

  }
};
</script>

<style lang="scss">
.playTab {
  background-color: #fff;
  width: 100%;
  padding: 15px 0;

  ul {
    display: flex;
    justify-content: center;

    li {
      width: 100px;
      text-align: center;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      border-radius: 3px;
      background-color: #e4e4e4;
      margin: 0 10px;
    }

    li.active {
      background-color: #0080d6;
      color: #fff;
    }
  }
}

.opacity {
  opacity: 0.5;
}


.detail-page {
  height: 100vh;
  background-color: #F9F9F9;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

.detail-page .back {
  position: absolute;
  left: 20px;
  top: 37px;
  z-index: 99;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 27px;
  width: 54px;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ddd;
}

.myToast {
  z-index: 1000000 !important;
}

.pdfMain {
  flex: 1;
  width: 100%;
  height: 100%;
  padding-bottom: 100px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;

  >div {
    flex: 1;
    width: 100%;
    height: 100%;
  }

  >p {
    font-size: 40px;
    font-weight: 500;
    color: #000000;
    padding: 16px;
  }
}

.main {
  flex: 1;
  width: 100%;
  padding: 40px 32px;

  .videoName {
    font-size: 40px;
    font-weight: 500;
    color: #000000;
    padding-bottom: 16px;

    span {
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
    }
  }
}

.contentMain {
  background: #fff;
  border-radius: 12px;
  margin: 24px 0;
  padding: 12px;

  img {
    width: auto;
    max-width: 100%;
  }
}

.video-wrap {
  width: 750px;
  height: 400px;
  position: relative;
}

.detail-page .video {
  width: 100%;
  height: 100%;
  background: #000;
}

.detail-page .price-cover {
  width: 100%;
  height: 100%;
}

.coverImg {
  position: relative;
  width: 100%;
  height: 100%;

  .tip {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;

    img {
      width: 100px;
      // height: 35px;
    }
  }
}

.detail-page .share {
  position: absolute;
  right: 0;
  top: 37px;
  width: 109px;
  height: 52px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 27px 0 0 27px;
  color: #ddd;
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}

.detail-page .share img {
  width: 24px;
  margin-right: 4px;
}


.detail-page .play {
  font-size: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-page .play img {
  height: 20px;
  margin-right: 10px;
}

.detail-page .time {
  width: 100%;
  font-size: 24px;
  text-align: right;
  box-sizing: border-box;
  position: absolute;
  right: 10px;
  bottom: 7px;
  color: rgb(85, 85, 85);
}

.is_play .play,
.is_play .time,
.is_play .lesson-name {
  color: #a7090a;
}

.is_play .lesson-name img {
  display: block;
  width: 22px;
  height: 26px;
}

.detail-page .lesson-content {
  width: 690px;
  margin: 20px auto;
  color: #666666;
}

.detail-page .footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 18px 30px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  box-shadow: 0px -1px 5px 0px rgba(221, 217, 217, 0.5);

  p {
    width: 160px;
    height: 64px;
    background: #FFFFFF;
    border-radius: 32px;
    border: 2px solid #E5E5E5;
    text-align: center;
    line-height: 64px;
    font-size: 24px;
    font-weight: 500;
    color: #333333;
  }

  .examin {
    background: #F08E00;
    border: 2px solid #F08E00;
    color: #fff;
  }

  .gray {
    background-color: #f4f4f4;
  }
}

.exmainMain {
  width: 600px;
  padding: 10px 32px 48px;
  box-sizing: border-box;

  h5 {
    font-size: 32px;
    font-weight: 500;
    color: #000000;
    line-height: 44px;
    text-align: center;
    display: block;
    margin-bottom: 54px;
  }

  >p {
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
    // text-align: center;
    margin-bottom: 26px;

    span {
      display: block;
    }
  }

  button {
    width: 160px;
    height: 64px;
    background: #F08E00;
    border-radius: 32px;
    border: 2px solid #F08E00;
    color: #fff;
    text-align: center;
    margin: 38px auto 0;
    line-height: 64px;
    display: block;
  }

  button.gray {
    background: #e4e4e4;
    border: 1px solid #e4e4e4;
    color: #666;
  }

  .options {
    p {
      width: 100%;
      box-sizing: border-box;
      line-height: 40px;
      padding: 20px 30px;
      background: #F9F9F9;
      border-radius: 48px;
      font-size: 28px;
      font-weight: 400;
      color: #000000;
      margin-bottom: 16px;
      border: 2px solid #F9F9F9;
    }

    p.active {
      color: #F08E00;
      border-color: #F08E00;
      border: 2px solid #F08E00;
    }
  }
}



.share-box {
  width: 750px;
  height: 164px;
  background: #fff;
  border-radius: 20px 20px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.share-box>div {
  margin: 0 65px;
  height: 94px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.share-box img {
  width: 94px;
  margin-right: 18px;
  font-size: 30px;
  color: #333;
}

.share-wrap {
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}

.share-wrap img:last-of-type {
  width: 137px;
  position: absolute;
  right: 68px;
  top: 0;
}

.share-wrap img:first-of-type {
  width: 269px;
  position: absolute;
  right: 54px;
  top: 140px;
}
</style>
